import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { uploadHourlyLaunch } from 'services/api/requests/uploads/uploads';

export const useUploadHourlyLaunch = (
	setSucessUpload,
	openTableModal,
	isOpen,
	onClose
) => {
	const toast = useToast();

	return useMutation(data => uploadHourlyLaunch(data), {
		onSuccess: sucess => {
			if (
				sucess.hasOwnProperty('quantidade_erros') &&
				sucess.quantidade_erros > 0
			) {
				console.log('Arquivo com erros!');
				openTableModal();
				setSucessUpload(false);
				if (!isOpen) {
					toast({
						title: 'Arquivo enviado com erros!',
						description:
							'O Arquivo enviado possui erros. Verifique a tabela de erros e corrija-os.',
						position: 'bottom-left',
						status: 'error',
						duration: 8000,
						isClosable: true,
					});
				}
			} else {
				console.log('Arquivo sem erros!');
				setSucessUpload(true);
				onClose();
			}
		},
		onError: () => {
			onClose();
			toast({
				title: 'Erro desconhecido!',
				description: 'Tente enviar novamente.',
				position: 'bottom-left',
				status: 'error',
				duration: 8000,
				isClosable: true,
			});
			setSucessUpload(false);
		},
	});
};
